import React, { useState, useRef, useEffect } from 'react';
import SoundBand from './SoundBand';
import './SoundGrid.css';

const SoundGrid = ({ sounds, favorites, onToggleFavorite, isFavorite, currentlyPlayingId, onPlay }) => {
  // Nombre d'éléments visibles (lazy loading)
  const BATCH_SIZE = 30;
  const [visibleCount, setVisibleCount] = useState(BATCH_SIZE);
  const loadMoreRef = useRef(null);

  // Observer pour charger plus quand le sentinel est visible
  useEffect(() => {
    if (!loadMoreRef.current) return;
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setVisibleCount(prev => Math.min(prev + BATCH_SIZE, sounds.length));
      }
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(loadMoreRef.current);
    return () => observer.disconnect();
  }, [sounds.length]);
  if (sounds.length === 0) {
    return (
      <div className="sound-grid-empty">
        <div className="empty-state">
          <span className="empty-icon">🎵</span>
          <h3>Aucun son disponible</h3>

        </div>
      </div>
    );
  }

  return (
    <div className="sound-grid">

      
      <div className="sound-grid-container">
        {sounds.slice(0, visibleCount).map(sound => (
          <SoundBand
            key={sound.id}
            sound={sound}
            isFavorite={isFavorite(sound.id)}
            onToggleFavorite={() => onToggleFavorite(sound)}
            isPlaying={currentlyPlayingId === sound.id}
            onPlay={() => onPlay(sound)}
          />
        ))}
      </div>
      {/* Sentinel pour l'Infinite Scroll */}
      {visibleCount < sounds.length && <div ref={loadMoreRef} className="load-more-sentinel" />}
    </div>
  );
};

export default SoundGrid;
